<script setup lang="ts">
import {Laboratory} from "@/core/interfaces/laboratory/Laboratory";
import useNotificationSequenceIndex from "@/notification-sequences/composables/useNotificationSequenceIndex";
import {NotificationSequenceCard} from "@/notification-sequences/components/notification-sequence-card";
import {useRouter} from "vue-router";
import useLaboratoryColor from "@/laboratory/composables/useLaboratoryColor";
import Icon from "@/core/components/icon/Icon.vue";

const router = useRouter();

const props = defineProps<{
    laboratory: Laboratory
}>();

const {primaryColor} = useLaboratoryColor({primary: props.laboratory.branding?.primary_color});
const {data} = useNotificationSequenceIndex({
    organization_id: props.laboratory.organization.id
});
</script>

<template>
  <div v-if="data?.length" :style="{backgroundColor: primaryColor}" class="p-4 space-y-4">
    <div class="flex gap-2">
      <Icon name="mdi-send" class="-rotate-45 text-white" :size="35" />
      <div class="text-white">
        <h3 class="text-lg">
          Séquences SMS
        </h3>
        <p>
          Automatisez le suivi de vos patients après un achat grâce à des SMS personnalisés, sans effort.<br>
          Un meilleur service, en quelques clics.
        </p>
      </div>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-4">
      <NotificationSequenceCard
        v-for="sequence in data"
        :key="sequence.id"
        :sequence="sequence"
        :color="laboratory.branding?.primary_color"
        @navigate="router.push({
          name: 'laboratory.sequence',
          params: {
            sequenceId: sequence.id,
            laboratoryId: laboratory.id
          }
        })"
      />
    </div>
  </div>
</template>
